/**
 * Controller: EntitiesListAddModal
 */
angular.module('acme.view.application.entities.list.addModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.view.application.entities.list.addModal.controllers'
])
.controller('EntitiesListAddModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'ValidateService', 'HelpersService', 'entityType', 'showUsers', 'allowCreate', function ($scope, $uibModalInstance, ApiService, ValidateService, HelpersService, entityType, showUsers, allowCreate) {

    $scope.isSubmitted = false;
    $scope.flags = {
      showingUsers: true,
      allowCreate: false,
      isCreate: false,
      nonEmailUser: false
    };

    $scope.search = {};
    $scope.users = [];
    $scope.errors = [];

    $scope.init = function() {

      if (showUsers) {
        $scope.flags.showingUsers = showUsers;
        $scope.showUsers();
      }

      if (allowCreate) {
        $scope.flags.allowCreate = allowCreate;
      }

      // Populate possible values to the model for use in modal
      if (entityType.plural === 'personnel') {
        $scope.model = {
          id: '',
          name: '',
          firstName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          isCurrentUser: false
        };

      }else {
        $scope.model = {
          name: '',
          description: '',
          capacity: null
        };
      }
    };

    $scope.isValidName = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.name } }
        ]);
      }

      return r;
    };

    $scope.isValidFirstName = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.firstName } }
        ]);
      }

      return r;
    };

    $scope.isValidLastName = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.lastName } }
        ]);
      }

      return r;
    };

    $scope.isValidEmail = function() {
      var r = true;
      if ($scope.isSubmitted && !$scope.flags.nonEmailUser) {
        r = ValidateService.validate([
          { email: $scope.model.email }
        ]);
      }

      return r;
    };

    $scope.isValidCapacity = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { greater: { less: 0, greater:  parseInt($scope.model.capacity, 10) } }
        ]);
      }
      return r;
    };

    $scope.isValidDescription = function() {
      var r = true;
      if ($scope.isSubmitted) {
        r = ValidateService.validate([
          { len: { value: $scope.model.description } }
        ]);
      }
      return r;

    };

    $scope.hasErrors = function () {
      return ($scope.errors.length > 0);
    };

    $scope.createUser = function() {

      var search = $scope.search.$,
          name = (search) ? search.split(' ') : ['',''];

      // Auto set form for creating user
      $scope.flags.showingUsers = false;
      $scope.flags.nonEmailUser = false;
      $scope.flags.isCreate = true;

      if (name instanceof Array) {
        if (name[0]) {
          $scope.model.firstName = name[0];
        }
        if (name[1]) {
          $scope.model.lastName = name[1];
        }
      }

    };

    $scope.selectUser = function(user) {

      $scope.flags.nonEmailUser = (user.userName && !user.email) ? true : false;

      $scope.model.id = user.id;
      if ($scope.flags.nonEmailUser) {
        $scope.model.email = '';
        $scope.model.userName = user.userName;
      }else{
        $scope.model.email = user.email;
        $scope.model.userName = '';
      }

      $scope.model.firstName = user.firstName || '';
      $scope.model.lastName = user.lastName || '';

      if (!$scope.flags.nonEmailUser && (user.firstName || user.lastName)) {
        $scope.model.name = user.firstName + ((user.firstName) ? ' ' : '') + user.lastName;
      }else if ($scope.flags.nonEmailUser) {
        $scope.model.name = user.userName;
      }

      $scope.model.phoneNumber = user.phoneNumber || '';
      $scope.model.isCurrentUser = $scope.flags.showingUsers;

      $scope.flags.isCreate = false;

    };

    $scope.showUsers = function() {
      var props = HelpersService.getPaginator();

      // Reset create user form and prepare for manual selection
      $scope.flags.showingUsers = false;
      $scope.errors = [];

      if ($scope.model) {
        $scope.model.firstName = '';
        $scope.model.lastName = '';
        $scope.model.email = '';
      }

      props.role = "user";
      ApiService.userProxy.list(props).then(function(response) {
        console.log('showUsers', $scope.flags.showingUsers);
        $scope.users = response.data.payload.list;
        $scope.flags.showingUsers = true;
      }, function(response) {
        //TODO: Implement
      });
    };
  
    
    $scope.create = function() {

      console.log('EntitiesListController::create', $scope.model.isCurrentUser);

      $scope.errors = [];

      switch(entityType.plural) {
        case 'personnel':
          if ($scope.flags.isCreate) {
            //only email address acceptable
            if ($scope.model.hasOwnProperty('email') && $scope.model.email.length > 0) {
              if ($scope.model.isCurrentUser) {
                ApiService.entity.convert({
                  type: entityType.plural,
                  id: $scope.model.id
                }).then($scope.success, $scope.handleError);
              }else{
                ApiService.entity.create({
                  type: entityType.plural,
                  email: $scope.model.email,
                  firstName: $scope.model.firstName || '',
                  lastName: $scope.model.lastName || ''
                }).then($scope.success, $scope.handleError);
              }
            } else {
              $scope.errors = [{
                message: 'Please enter a valid email address.'
              }];
            }
          } else if ($scope.model.isCurrentUser) {
            ApiService.entity.convert({
              type: entityType.plural,
              id: $scope.model.id
            }).then($scope.success, $scope.handleError);
          } else if ($scope.model.hasOwnProperty('name') && $scope.model.name.length > 0) {
            ApiService.entity.create({
              type: entityType.plural,
              email: $scope.model.email,
              userName: $scope.model.userName,
              firstName: $scope.model.firstName || '',
              lastName: $scope.model.lastName || ''
            }).then($scope.success, $scope.handleError);
          }
          break;
        case 'equipment':
          if ($scope.model.hasOwnProperty('name') && $scope.model.name.length > 0) {
            ApiService.resource.equipment.create($scope.model).then($scope.success, $scope.handleError);
          }
          break;
        case 'facilities':
          if ($scope.model.hasOwnProperty('name') && $scope.model.name.length > 0) {
            ApiService.resource.facilities.create($scope.model).then($scope.success, $scope.handleError);
          }
          break;
      }
    };

    $scope.done = function () {

      var tests = [
        { len: { value: $scope.model.name } },
        { len: { value: $scope.model.description } }
      ];

      $scope.isSubmitted = true;
      if (entityType.plural === 'facilities') {
        tests.push({ greater: { less: 0, greater: parseInt($scope.model.capacity, 10) } });
      }else if (entityType.plural === 'personnel') {
        if ($scope.flags.showingUsers) {
          if (!$scope.flags.isCreate) {
            if (!$scope.flags.nonEmailUser) {
              tests = [
                { email: $scope.model.email }
              ];
            }else{
              tests = [{ len: { value: $scope.model.name } }];
            }
          }else{
            tests = [];
          }
        }else{
          tests = [
            { len: { value: $scope.model.firstName } },
            { len: { value: $scope.model.lastName } }
          ];
          if (!$scope.flags.nonEmailUser) {
            tests.push({ email: $scope.model.email });
          }
        }
      }
      if (ValidateService.validate(tests)) {
        $scope.create();
      }else{
        $scope.errors = [{
          message: 'Please correct the errors below'
        }];
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function (response) {
      $uibModalInstance.close({entity: $scope.model, response: response});
    };

    $scope.handleError = function(response) {
      $scope.errors = [{
        message: response.data.error
      }];
    };

    $scope.init();
}]);